module.exports = __webpack_public_path__ + "img/con4_img1.8ddce0d9.png";